export const FORM_NAME = Object.freeze({
  modality: 'modality',
})
